import { useCallback } from 'react';
import { Dispatch } from 'redux';
import { useDispatch, useSelector } from 'react-redux';
import { StoreState } from '@mm/state/store-interfaces';
import modalActions from '@mm/state/modules/modalsState/actions';
import { activeChatbotIdSelector } from '@mm/state/selectors/viewSelectors';
import { useCampaignsOverviewCRUDActions } from '@mm/state/actions/CampaignsOverviewCRUDActions';
import { UICampaignItem } from '@mm/state/reducers/campaignsOverview';
import { useCampaignCRUDActions } from '@mm/state/actions/CampaignsCRUDActions';
import { CampaignType } from '@mm/state/model/CampaignsModel';

export const useDeleteCampaign = () => {
  const activeChatbotId = useSelector(activeChatbotIdSelector);

  const campaignsOverviewCRUDActions = useCampaignsOverviewCRUDActions();
  const { update } = useCampaignCRUDActions();

  const dispatch: Dispatch<StoreState> = useDispatch();
  const adCampaignDeleteHeader = (
    name: string,
  ) => `Deleting this campaign won't delete it from Facebook Ads Manager. 
  Are you sure you want to delete ${name}?`;

  const openDeleteConfirmModal = (
    item: UICampaignItem,
    deleteCallback: () => any,
  ) =>
    dispatch(
      modalActions.openDeleteConfirmModal({
        headerText:
          item.kind === 'ctm_ads' || item.kind === 'sponsored'
            ? adCampaignDeleteHeader(item.name)
            : `Are you sure you want to delete this ${item.name}?`,
        deleteCallback,
      }),
    );

  const deleteCampaign = useCallback(
    (item: UICampaignItem) => {
      if (activeChatbotId) {
        openDeleteConfirmModal(item, () => {
          campaignsOverviewCRUDActions.deleteByKindAndId(
            activeChatbotId,
            item.kind,
            item.id,
          );
        });
      }
    },
    [activeChatbotId],
  );

  const updateCampaign = useCallback(
    (item: CampaignType, onUpdate: () => void) => {
      if (activeChatbotId) {
        update(item, item.id, true, onUpdate);
      }
    },
    [activeChatbotId],
  );

  return { deleteCampaign, updateCampaign };
};
